// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';
import * as vo from 'settings/visibility-options/VisibilityOptions';
import {constructOptions} from 'settings/visibility-options/VisibilityOptions';
import BaseEntryProtocolTabState from 'notebook/entries/backbone/tabs/BaseEntryProtocolTab';

class EntryProtocolTabState extends BaseEntryProtocolTabState {
  defaults() {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(super.defaults(), {
      displayOptions: constructOptions('protocol', [
        {base: vo.ELN_SPELL_CHECK, visible: false, editable: true, sync: true},
        {base: vo.ELN_PRINT_LAYOUT, visible: false, editable: true, sync: true},
      ]),
    });
  }
}
export default EntryProtocolTabState;
